module.exports = __webpack_public_path__ + "img/qrCode.ee729365.png";